module.exports = __webpack_public_path__ + "static/media/right_QR_code.60c90f0e.png";